import * as icon from './com'
import { setIcon } from "../utils"
export const icons = { ...icon }



import { defineComponent } from "vue"

export const IconProps = {
    name: { default: "user", type: String },
    size: { default: "", type: String },
    color: { default: "", type: String },
    dot: { default: false, type: Boolean },
    badge: { default: "", type: String },
    iconIndex: { default: "0", type: [String, Number] },
}
export default defineComponent({
    name: 'fan-icon',
    props: Object.assign({}, IconProps),
    emits: ['click'],
    setup(props, { emit, slots }) {
        const IsUrl = /\//g.test(props.name);
        const style = {}
        if (props.size) { style.width = props.size; style.height = props.size }
        if (props.color) { style.color = props.color }


        function iconRender() {
            const IconCom = setIcon(icons, props.name)
            return (
                <IconCom style={style} />
                // <span style="display:inline-block;min-width:40px;">{name}</span>
            )
        }
        function imageRender() {
            return (
                <img src={props.name} style={style} />
            )
        }

        function onClick(event) {
            emit('click', event)
        }
        return () => (
            <div class="fan-icon" onClick={onClick}>
                {IsUrl ? imageRender() : iconRender()}
                {props.dot ? <i class={`fan-icon--dot`}></i> : null}
                {props.badge ? <i class={`fan-icon--badge ${!props.badge ? 'fan-icon-badge-empty' : ''}`}>{props.badge}</i> : null}
            </div>
        )
    }
})